import { FC } from 'react';
import type { LucideIcon } from 'lucide-react';

interface NavigationButtonProps {
  onClick: () => void;
  icon: LucideIcon;
  ariaLabel: string;
}

export const NavigationButton: FC<NavigationButtonProps> = ({ onClick, icon: Icon, ariaLabel }) => {
  return (
    <button
      onClick={onClick}
      className="p-2 hover:bg-(--neutral-black-NB100) rounded-full! transition-colors cursor-pointer"
      aria-label={ariaLabel}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
};
